/* AE Ebook Library — one free guide per reader */
(function () {
  function init(root) {
    if (root.dataset.aeEbooksInit === '1') return;
    root.dataset.aeEbooksInit = '1';

    var key = root.dataset.storageKey || 'ae_ebook_claim_v1';
    var pickNote = root.dataset.pickNote || '';
    var claimedNote = root.dataset.claimedNote || '';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ebook-card]'));
    var status = root.querySelector('[data-ebooks-status]');
    var statusText = root.querySelector('[data-ebooks-status-text]');
    var confirmModal = root.querySelector('[data-ebooks-confirm]');
    var confirmTitle = root.querySelector('[data-ebooks-confirm-title]');
    var confirmYes = root.querySelector('[data-ebooks-confirm-yes]');
    var previewModal = root.querySelector('[data-ebooks-preview]');
    var previewBody = root.querySelector('[data-ebooks-preview-body]');
    var pending = null;
    var lastFocus = null;

    function readClaim() {
      try { return window.localStorage.getItem(key) || ''; } catch (e) { return ''; }
    }
    function writeClaim(id) {
      try { window.localStorage.setItem(key, id); } catch (e) {}
    }
    function cardById(id) {
      for (var i = 0; i < cards.length; i++) if (cards[i].dataset.ebookId === id) return cards[i];
      return null;
    }

    function render() {
      var claimed = readClaim();
      if (claimed && !cardById(claimed)) claimed = '';
      cards.forEach(function (card) {
        var isChosen = claimed && card.dataset.ebookId === claimed;
        var isLocked = claimed && !isChosen;
        var choose = card.querySelector('[data-ebook-choose]');
        var download = card.querySelector('[data-ebook-download]');
        var locked = card.querySelector('[data-ebook-locked]');
        var chosenBadge = card.querySelector('[data-ebook-chosen]');
        card.classList.toggle('is-chosen', !!isChosen);
        card.classList.toggle('is-locked', !!isLocked);
        if (choose) choose.hidden = !!claimed;
        if (download) download.hidden = !isChosen;
        if (locked) locked.hidden = !isLocked;
        if (chosenBadge) chosenBadge.hidden = !isChosen;
      });
      if (status) status.classList.toggle('is-claimed', !!claimed);
      if (statusText) {
        if (claimed) {
          var title = cardById(claimed).dataset.ebookTitle || '';
          statusText.textContent = claimedNote.replace('{title}', title);
        } else {
          statusText.textContent = pickNote;
        }
      }
    }

    function openModal(modal) {
      if (!modal) return;
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('ae-ebooks-lock');
      var focusable = modal.querySelector('button, a, [tabindex]');
      if (focusable) focusable.focus();
    }
    function closeModals() {
      [confirmModal, previewModal].forEach(function (m) { if (m) m.hidden = true; });
      document.documentElement.classList.remove('ae-ebooks-lock');
      pending = null;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function startDownload(card) {
      var url = card.dataset.ebookUrl;
      if (!url) return;
      var a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      a.remove();
    }

    function askToChoose(card) {
      if (readClaim()) return;
      pending = card;
      if (confirmTitle) confirmTitle.textContent = card.dataset.ebookTitle || '';
      openModal(confirmModal);
    }

    function openPreview(card) {
      var tpl = card.querySelector('[data-ebook-preview-tpl]');
      if (!tpl || !previewBody) return;
      previewBody.innerHTML = '';
      previewBody.appendChild(tpl.content.cloneNode(true));
      var actions = previewBody.querySelector('[data-preview-actions]');
      if (actions) {
        var claimed = readClaim();
        var isChosen = claimed && claimed === card.dataset.ebookId;
        if (isChosen) {
          var dl = card.querySelector('[data-ebook-download]');
          if (dl) {
            var clone = dl.cloneNode(true);
            clone.hidden = false;
            clone.removeAttribute('data-ebook-download');
            actions.appendChild(clone);
          }
        } else if (claimed) {
          var lk = card.querySelector('[data-ebook-locked]');
          if (lk) {
            var lkClone = lk.cloneNode(true);
            lkClone.hidden = false;
            actions.appendChild(lkClone);
          }
        } else {
          var ch = card.querySelector('[data-ebook-choose]');
          if (ch) {
            var chClone = ch.cloneNode(true);
            chClone.hidden = false;
            chClone.removeAttribute('data-ebook-choose');
            chClone.addEventListener('click', function () {
              closeModals();
              askToChoose(card);
            });
            actions.appendChild(chClone);
          }
        }
      }
      openModal(previewModal);
    }

    cards.forEach(function (card) {
      var choose = card.querySelector('[data-ebook-choose]');
      var preview = card.querySelector('[data-ebook-preview]');
      if (choose) choose.addEventListener('click', function () { askToChoose(card); });
      if (preview) preview.addEventListener('click', function () { openPreview(card); });
    });

    if (confirmYes) {
      confirmYes.addEventListener('click', function () {
        if (!pending) return;
        var card = pending;
        writeClaim(card.dataset.ebookId);
        closeModals();
        render();
        startDownload(card);
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    root.querySelectorAll('[data-ebooks-close]').forEach(function (el) {
      el.addEventListener('click', closeModals);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModals();
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-ae-ebooks]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-ae-ebooks]') : null;
    if (root) init(root);
  });
})();
